export default "__VITE_ASSET__d2bb549b__"